module.exports = __webpack_public_path__ + "static/media/dollar-sign.1afd551b.svg";